var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM45(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5438_45427",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5438_45427",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVRo3u2aTW6DMBCFs8suana5QNoj0MIpmgXZsA0H8J4LhOtwjkZIzZpdOQKLCLkz6tA61Ak0MTAj1dInRYDt98B/Y2c2+08/6W35uAB8IAIUkBCKruG9BSfBiAekQA7UgO6gpmcxzzOWMYXwObADjj0Ed4FlxFjmWG88BAoHwttgmdvDcj2Y+BWQDSC8Ddaxci0+AMoRxDdgXYEr8RugGlF8A9a5cSH+NIH4htPNJqjZVBOKN79EcEuHLRmIN/tEv459+BoqM0bijdFp3evtbxmKbwj7zLAFYwPF1RmbpnTNnNgu/uFp5mhtMzRH1Gp7+54A8Q2ezUAqyEBqM5ALMpDbIqlakIH6LLKjUE8LwzcNRAINRKYBJdCAMg0kAg0k3wa01omWl84MKIEGlGkgEmggMg34Ag34poEFUAsSj1rPtyjhQi7IQP5rLQQXU0EG9jYDniADns0AchQgHjXaQ0q4EQswsLsYE8PNOVAwFo/arm/DwwMhYwNh574Q9YWMofjsYtu3mFgBJSPxqOVvZwaQIQAqBuJRw21nBZDxFThNKB7rvu+MAAuY6EtUd4tvNaePkdt84PScjDp2NtJo4/aQrzXEhgNNdgWVPfxBN83YO+Dd0dom7pxhB/wiuIrdUzzRJyiq6dmU8vL5swdFdi8UYyva7Ujod0ShK58/e3BIn8koaEC6je9PAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM45);
export default __webpack_public_path__ + "static/media/m45.1c40533361bb991f45a3201b319f70b0.svg";
export { ForwardRef as ReactComponent };